import type { IOrderProductItem } from 'src/types';
import { toFiniteNumber } from 'src/utils/strict-number';

/**
 * Stock on hand valued at cost — computed here rather than read from `stock_value`, which the
 * nightly job refreshes and so can lag a delivery or a sale made today.
 *
 * Null unless both the quantity and the cost are real numbers: a missing cost turned into €0
 * would understate the wine's value, and a total that sums these must say so rather than
 * silently treating "unknown" as "worth nothing". Read by the list on screen and by its XLSX
 * export (NAT-2481): one definition, so the two cannot disagree.
 */
export const valueAtCost = (row: IOrderProductItem): number | null => {
  const quantity = toFiniteNumber(row.storage_quantity);
  const cost = toFiniteNumber(row.cost);
  return quantity !== null && cost !== null ? quantity * cost : null;
};
